// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grid-layout-container[data-v-9bf3f682]{display:grid;width:100%;justify-content:center}", ""]);
// Exports
module.exports = exports;
